import { useEffect, useRef } from 'react';
import AuthService from '@/services/auth';
import EventBus from '@/utils/eventBus';

/**
 * 用户信息初始化 Hook
 * 在应用启动时或页面刷新时，如果存在 accessToken 则自动获取用户信息
 */
export default function useUserInfoInit() {
    const initRequested = useRef(false);

    useEffect(() => {
        // 确保初始化请求只执行一次
        if (initRequested.current) return;
        initRequested.current = true;

        const initUserInfo = async () => {
            const accessToken = AuthService.getAccessToken();
            
            // 只有在存在 accessToken 时才获取用户信息
            if (accessToken) {
                try {
                    const userInfo = await AuthService.fetchAndUpdateUserInfo();
                    if (userInfo) {
                        // 触发用户信息更新事件
                        EventBus.emit('userInfoUpdated', userInfo);
                        console.log('用户信息已更新:', userInfo);
                    }
                } catch (error) {
                    console.error('初始化用户信息失败:', error);
                }
            }
        };

        initUserInfo();
    }, []);

    // 监听页面可见性变化，当页面重新获得焦点时刷新用户信息
    useEffect(() => {
        const handleVisibilityChange = async () => {
            if (!document.hidden && AuthService.getAccessToken()) {
                try {
                    const userInfo = await AuthService.fetchAndUpdateUserInfo();
                    if (userInfo) {
                        EventBus.emit('userInfoUpdated', userInfo);
                    }
                } catch (error) {
                    console.error('刷新用户信息失败:', error);
                }
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
}